import { create } from "zustand"

export interface ApplicantDetailsState {
    tcn: string
    ori: string
    nistOriginalDisplayId: string
    nistOriginalParentId: string
    incompleteStatuses: string[]
    applicantDetailFields: object
    applicantHeader: any
    setNistOriginalDisplayId: Function
    setNistOriginalParentId: Function
    setTcn: Function
    setOri: Function
    setIncompleteStatuses: Function
    setApplicantDetailFields: Function
    setApplicantHeader: Function
    documentSelected: boolean
    setDocumentSelected: Function
    docs: Array<any>
    setDocs: Function
}

const initialState: ApplicantDetailsState = {
    nistOriginalDisplayId: "",
    nistOriginalParentId: "",
    tcn: "",
    ori: "",
    incompleteStatuses: [],
    applicantDetailFields: {},
    applicantHeader: [],
    documentSelected: false,
    docs: [],
    setNistOriginalDisplayId: () => { },
    setNistOriginalParentId: () => { },
    setTcn: () => { },
    setOri: () => { },
    setIncompleteStatuses: () => { },
    setApplicantDetailFields: () => { },
    setApplicantHeader: () => { },
    setDocumentSelected: () => { },
    setDocs: () => {

    }
}

export const useApplicantDetailsStore = create<ApplicantDetailsState>((set, get) => ({
    ...initialState,
    setNistOriginalParentId: (nistOriginalParentId: string) => set({ nistOriginalParentId }),
    setNistOriginalDisplayId: (nistOriginalDisplayId: string) => set({ nistOriginalDisplayId }),
    setTcn: (tcn: string) => set({ tcn }),
    setOri: (ori: string) => set({ ori }),
    setIncompleteStatuses: (incompleteStatuses: string[]) => set({ incompleteStatuses }),
    setApplicantDetailFields: (applicantDetailFields: object) => set({ applicantDetailFields }),
    setApplicantHeader: (applicantHeader: any) => set({ applicantHeader }),
    setDocumentSelected: (documentSelected: boolean) => set({ documentSelected }),
    setDocs: (docs: object[]) => set({ docs })
}))
